<template src="./templates/Map.html" />

<script setup>

import { onMounted } from 'vue';

import {
    useLocationsStore,
    useMap,
    useQueryParamsStore,
    useRegionsStore,
    useResultsStore,
    useMapStore,
} from '@timezoneone/dottie-client-jam';
import { config } from '../config/config.js';

const queryParams = useQueryParamsStore();
const regionsStore = useRegionsStore();
const locationsStore = useLocationsStore();
const resultsStore = useResultsStore();
const mapStore = useMapStore();

const { initMap, toggleMap, searchByBounds } = useMap(
    config,
    regionsStore,
    locationsStore,
    resultsStore,
    queryParams,
    mapStore,
);

onMounted(() => {

    initMap();

});

</script>
